import { __ } from '@wordpress/i18n';
import { useState } from '@wordpress/element';
import {PanelBody, Button, RangeControl, FocalPointPicker, __experimentalUnitControl as UnitControl} from '@wordpress/components';
import { VayuBlocksSize, VayuBlocksBackground,VayuBlockBorderFrame,
    VayuBlocksToggleControl,VayuBlocksBorder,VayuBlocksDimensions} from '@vayu-blocks';
import {MediaUpload } from '@wordpress/block-editor';
import noimagelong from "../../../../../../inc/assets/img/no-image-long.png";
import { SlideButton } from '@vayu-blocks/global';
import { VayuBlocksDevice,VayuBlocksDeviceControl } from '@vayu-blocks/device-control';

const SlideSettings = ({ attributes, setAttributes, openPanels, onTogglePanel }) => {

    const getView = VayuBlocksDevice();
    const [hover, sethover] = useState('normal');
    const [firstDesktop, setFirstDesktop] = useState(false);
    const [firstTablet, setFirstTablet] = useState(false);

    const handleImageChange = (media) => {
        if (media && media.url) {
            setAttributes({ poimage: media.url });
        }
    };

    const overlaychange = (value) => {
        setAttributes({
            posterOn: value,
            preview: value ? 'preview' : 'default',
            lightbox: value ? '' : false,
        })

        if(value){
            setAttributes({
                autoplay:true ,
                youautoplay:true ,
                vimeoautoplay:true,
            })
               
        }
    }
    
    const handelHover = (value) => {
        sethover(value);
        if (typeof clickBorderHover === 'function') {
            clickBorderHover(value);
        }
    }

    const changevalue = (data, value) => {

        const updatedAttributes = {
            ...attributes.position,
            [data]: {
               ...attributes.position?.[data],
               [getView]: value
            },
        };

        const isFirstRun = !attributes.position?.[data]?.[getView];
        const isTabletFirstRun = localStorage.getItem('firstTablet') || firstTablet;

        if (getView === 'Desktop') {
            if (isFirstRun || firstDesktop) {
                updatedAttributes[data]['Tablet'] = value;
                updatedAttributes[data]['Mobile'] = value;
                localStorage.setItem('firstTablet', 'true');
                setFirstTablet(true);
                setFirstDesktop(true);
            }
        } else if (getView === 'Tablet') {
            if (isTabletFirstRun) {
                updatedAttributes[data]['Mobile'] = value;
                localStorage.removeItem('firstTablet');
                setFirstTablet(true);
                setFirstDesktop(false);
            }
        } else {
            setFirstTablet(false);
            setFirstDesktop(false);
        }

        setAttributes({ position: updatedAttributes });

    }
    
    return (
        
        <div class="vb-video-panel vayu_blocks_image-settings_main">
            
            <PanelBody 
                title={__('Poster','vayu-blocks')} 
                opened={openPanels['overlay-poster']}
                onToggle={() => onTogglePanel('overlay-poster')}
            >
                    <VayuBlocksToggleControl
                        label={__('Poster Image', 'vayu-blocks')}
                        checked={attributes.posterOn}
                        onChange={(value) =>overlaychange(value)}
                    /> 

                {attributes.posterOn && (
                    <>
                            <SlideButton  
                            button={{ preview: "Preview", default: "Default" }}
                            onChange={(value)=>setAttributes({preview:value})}
                            defaultValue={attributes.preview}
                        />  
    
                        <div className='vayu_blocks_focal_point'>     
                            <FocalPointPicker
                                className='vayu_blocks_focal_point_picker'
                                __nextHasNoMarginBottom={true}
                                url={ attributes.poimage }
                                value={ attributes.pofocalPoint || noimagelong }
                                onDragStart={ (value)=> setAttributes({pofocalPoint:value})}
                                onDrag={ (value)=> setAttributes({pofocalPoint:value}) }
                                onChange={ (value)=> setAttributes({pofocalPoint:value}) }
                            />

                            <div className="vayu_blocks_replace_button_image vb-video-focal-picker">
                                <MediaUpload
                                    onSelect={handleImageChange}
                                    allowedTypes={['image']}
                                    render={({ open }) => (
                                        <Button
                                            onClick={open}
                                        >
                                            {__('Replace', 'vayu-blocks')}
                                        </Button>
                                    )}
                                />
                            </div>
                        </div>

                        <VayuBlocksBackground
                            onChange={(key,value)=>setAttributes({[key]:value})}
                            colorPanel = {[
                                {
                                    active: ['gradient'],
                                    label: 'Overlay',
                                    key:'pooverlaycolor',
                                    value:attributes.pooverlaycolor,
                                },
                                {
                                    active: ['gradient'],
                                    label: 'Hover',
                                    key:'pooverlayhvrcolor',
                                    value:attributes.pooverlayhvrcolor,
                                },
                            ]}
                        />

                        <RangeControl
                            __nextHasNoMarginBottom={true}
                            __next40pxDefaultSize={true}
                            initialPosition={ 5 }
                            label={__('Opacity','vayu-blocks')}
                            max={ 10 }
                            min={ 0 }
                            marks
                            value={ attributes.pooverlayopacity *10}
                            onChange={ (value) => setAttributes({pooverlayopacity:value/10})}
                        />

                    </>
                )}
            
            </PanelBody >

            {attributes.posterOn && (
            <>
                <PanelBody 
                    title={__('Lightbox','vayu-blocks')}   
                    opened={openPanels['overlay-lightbox']}
                    onToggle={() => onTogglePanel('overlay-lightbox')}
                >

                    <VayuBlocksToggleControl
                        label={__('LightBox', 'vayu-blocks')}
                        checked={attributes.lightbox}
                        onChange={(value) => setAttributes({ lightbox: value })}
                    />

                    {attributes.lightbox && (
                        <>
                            <VayuBlocksBackground
                                onChange={(key,value)=>setAttributes({[key]:value})}
                                colorPanel = {[
                                    {
                                        active: ['gradient'],
                                        label: 'Background',
                                        key:'lightboxcolor',
                                        value:attributes.lightboxcolor,
                                    }
                                ]}
                            />
                        </>
                    )}

                </PanelBody>
            </>
            )}

            {attributes.lightbox && (
            <>
                <PanelBody 
                    title={__('Lightbox Cancel Button','vayu-blocks')}   
                    opened={openPanels['overlay-button']}
                    onToggle={() => onTogglePanel('overlay-button')}
                >

                    <VayuBlocksDimensions  
                        onChange={(key,value)=>setAttributes({[key]:value})}
                        dimensions = {{
                            padding:{key:'cancelpadding',value:attributes.cancelpadding},
                        }}
                    />

                    <VayuBlocksSize
                        size={{key:'cancelSize', value:attributes.cancelSize}}
                        onChange={(key,value)=>setAttributes({[key]:value})}
                    />
                    
                    <br/>

                    <SlideButton  
                        button={{ normal: "Normal", hover: "Hover" }}
                        onChange={(value)=>handelHover(value)}
                        defaultValue={'normal'}
                    /> 

                    { 'normal' ===  hover &&  (	
                    <>
                        <VayuBlocksBackground
                            onChange={(key,value)=>setAttributes({[key]:value})}
                            colorPanel = {[
                                {
                                    active: ['gradient'],
                                    label: 'Color',
                                    key:'cancelcolor',
                                    value:attributes.cancelcolor,
                                },
                                {
                                    active: ['gradient'],
                                    label: 'Background',
                                    key:'cancelbg',
                                    value:attributes.cancelbg,
                                }
                            ]}
                        />

                        <VayuBlocksBorder 
                            onChange={(key,value)=>setAttributes({[key]:value})}
                            border={{key:'cancelBorder',value:attributes.cancelBorder}}
                            borderRadius={{key:'cancelRadius',value:attributes.cancelRadius}}
                            dropShadow = {{key:'cancelDropShadow',value:attributes.cancelDropShadow}}
                        />
                    </>

                    ) || 'hover' ===  hover && (
                    <>
                        <VayuBlocksBackground
                            onChange={(key,value)=>setAttributes({[key]:value})}
                            colorPanel = {[
                                {
                                    active: ['gradient'],
                                    label: 'Color',
                                    key:'cancelcolorhover',
                                    value:attributes.cancelcolorhover,
                                },
                                {
                                    active: ['gradient'],
                                    label: 'Background',
                                    key:'cancelbghover',
                                    value:attributes.cancelbghover,
                                }
                            ]}
                        />

                        <VayuBlocksBorder 
                            onChange={(key,value)=>setAttributes({[key]:value})}
                            border={{key:'cancelBorderHover',value:attributes.cancelBorderHover}}
                            borderRadius={{key:'cancelRadiusHover',value:attributes.cancelRadiusHover}}
                            dropShadow = {{key:'cancelDropShadowHover',value:attributes.cancelDropShadowHover}}
                        />
                    </>
                    )}
                    
                </PanelBody>
            </>
            )}
            
            <PanelBody title={__('Border & Frame','vayu-blocks')}   
                opened={openPanels['overlay-frame']}
                onToggle={() => onTogglePanel('overlay-frame')}>

                <VayuBlockBorderFrame
                    frameData={attributes.frameData}
                    onChange={(key,value)=>setAttributes({[key]:value})}
                    dataKey="frameData"
                />
        
            </PanelBody>

            <PanelBody title={__('Position/Width', 'vayu-blocks')} opened={openPanels['overlay-position']} onToggle={() => onTogglePanel('overlay-position')}>
                <>

                    <span> {<VayuBlocksDeviceControl label={__('Position/Width', 'vayu-blocks')} classname='bold'/>}</span>

                    <div className='vayu_block_width_height_control_overlay'>

                        <UnitControl
                            label={__('Width', 'vayu-blocks')}
                            placeholder={ __( 'Auto' ) }
                            labelPosition="top"
                            size="__unstable-large"
                            className="vayu_block_unit_width_control"
                            onChange={(value) =>changevalue('width',value)}
                            value={attributes.position?.width?.[getView]}
                            max={200} // Maximum width
                            min={2} // Minimum width
                            units={[
                                {
                                a11yLabel: 'Percentage (%)',
                                label: '%',
                                step: 1,
                                value: '%'
                                }
                            ]}
                        />
                
                        <UnitControl
                            label={__('Height', 'vayu-blocks')}
                            placeholder={ __( 'Auto' ) }
                            labelPosition="top"
                            size="__unstable-large"
                            className="vayu_block_unit_width_control"
                            onChange={(value) =>changevalue('height',value)}
                            value={attributes.position?.height?.[getView]}
                            max={200} // Maximum width
                            min={2} // Minimum width
                            units={[
                                {
                                a11yLabel: 'Percentage (%)',
                                label: '%',
                                step: 1,
                                value: '%'
                                }
                            ]}
                        />
                
                    </div>

                    <div className='vayu_block_width_height_control_overlay'>

                            <UnitControl
                                label={__('Left', 'vayu-blocks')}
                                placeholder={ __( 'Auto' ) }
                                labelPosition="top"
                                size="__unstable-large"
                                className="vayu_block_unit_width_control"
                                onChange={(value) =>changevalue('left',value)}
                                value={attributes.position?.left?.[getView]}
                                max={1500} // Maximum width
                                min={-500} // Minimum width
                                units={[
                                    {
                                        a11yLabel: 'Percentage (px)',
                                        label: 'px',
                                        step: 1,
                                        value: 'px'
                                    }
                                ]}
                            />
                        
                            <UnitControl
                                label={__('Top', 'vayu-blocks')}
                                placeholder={ __( 'Auto' ) }
                                labelPosition="top"
                                size="__unstable-large"
                                className="vayu_block_unit_width_control"
                                onChange={(value) =>changevalue('top',value)}
                                value={attributes.position?.top?.[getView]}
                                max={1500} // Maximum width
                                min={-500} // Minimum width
                                units={[
                                    {
                                    a11yLabel: 'Percentage (px)',
                                    label: 'px',
                                    step: 1,
                                    value: 'px'
                                    }
                                ]}
                            />
                    </div>

                </>
            </PanelBody> 

        </div>

    );
};

export default SlideSettings;